import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";
import {EmployeeTagFilterMixin, HotelFilterMixin} from "./FilterMixin";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import {axiosGet} from "../../../common/Helper/AxiosHelper";

export default {
    mixins: [HelperMixin, DatatableHelperMixin, HotelFilterMixin, EmployeeTagFilterMixin],
    data() {
        return {
            options: {
                name             : this.$t('house-keeping'),
                url              : this.hotel.id ?
                                   `${TENANT_BASE_URL}app/hotel/house-keeping?hotels=${this.hotel.id}` :
                                   `${TENANT_BASE_URL}app/hotel/house-keeping`,
                preserveState    : true,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title      : this.$t('date'),
                        type       : 'custom-html',
                        key        : 'date',
                        tdClassName: 'text-nowrap',
                        isVisible  : true,
                        modifier   : (value) => formatDateToLocal(value)
                    },
                    {
                        title    : this.$t('hotel'),
                        type     : 'custom-html',
                        key      : 'hotel',
                        isVisible: true,
                        modifier : (hotel) => {
                            return hotel ? '<span class="text-nowrap">' + hotel.name + '</span>' : '';
                        }
                    },
                    // {
                    //     title        : this.$t('staff'),
                    //     type         : 'component',
                    //     key          : 'maid',
                    //     isVisible    : true,
                    //     componentName: 'image-group',
                    // },
                    {
                        title    : this.$t('staff'),
                        type     : 'custom-html',
                        key      : 'maid',
                        isVisible: true,
                        modifier : (users) => {
                            const html = []
                            if (users.length > 0) {
                                for (const user of users) {
                                    html.push('<span class="text-nowrap">' + user.full_name + ' (' + user.employee_id + ')</span>')
                                }
                            }
                            return html.join(', ');
                        }
                    },
                    {
                        title    : this.$t('room'),
                        type     : 'custom-html',
                        key      : 'room',
                        isVisible: true,
                        modifier : (value, row) => {
                            const room = value ? value.number : ''
                            const type = row.room_type ? row.room_type.name : ''

                            return `<span class="text-nowrap">${room}-${type}</span>`;
                        }
                    },
                    {
                        title    : this.$t('staying'),
                        type     : 'custom-html',
                        key      : 'staying',
                        isVisible: true,
                        modifier : (staying) => {
                            return staying ? '<span class="text-nowrap">' + staying.name + '</span>' : '';
                        }
                    },
                    {
                        title    : this.$t('cleaning'),
                        type     : 'custom-html',
                        key      : 'cleaning',
                        isVisible: true,
                        modifier : (cleaning) => {
                            return cleaning ? '<span class="text-nowrap">' + cleaning.name + '</span>' : '';
                        }
                    },
                    {
                        title        : this.$t('options'),
                        type         : 'expandable-column',
                        key          : 'options',
                        isVisible    : true,
                        componentName: 'app-hotel-house-keeping-option',
                        modifier     : (options) => {
                            return {
                                title     : this.$t('options') + ' (' + options.length + ')',
                                expandable: options.length > 0,
                                className : 'success'
                            };
                        }
                    },
                    {
                        title    : this.$t('start_time'),
                        type     : 'text',
                        key      : 'start_time',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('end_time'),
                        type     : 'text',
                        key      : 'end_time',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('payment'),
                        type     : 'custom-html',
                        key      : 'payment',
                        isVisible: true,
                        modifier : (payment) => {
                            return parseInt(payment).toFixed(2)
                        }
                    },
                    {
                        title        : this.$t('confirmed'),
                        type         : 'component',
                        key          : 'confirmed',
                        isVisible    : true,
                        componentName: 'app-hotel-house-keeping-confirmed',
                    },
                    {
                        title      : this.$t('created_by'),
                        type       : 'custom-html',
                        key        : 'created',
                        tdClassName: 'text-nowrap',
                        isVisible  : true,
                        modifier   : (user) => {
                            return user ? user.full_name : '';
                        }
                    },
                    {
                        title      : this.$t('edit_by'),
                        type       : 'custom-html',
                        tdClassName: 'text-nowrap',
                        key        : 'edited',
                        isVisible  : true,
                        modifier   : (user) => {
                            return user ? user.full_name : '';
                        }
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('hotel'),
                        type          : "multi-select-filter",
                        key           : "hotels",
                        option        : [],
                        listValueField: 'name',
                        permission    : !!this.$can('view_hotel_list') && !this.hotel.id,
                    },
                    {
                        title         : this.$t('floor'),
                        type          : "multi-select-filter",
                        key           : "floor",
                        option        : [],
                        listValueField: 'name',
                        permission    : !!this.$can('view_hotel_room')
                    },
                    {
                        title         : this.$t('member'),
                        type          : "multi-select-filter",
                        key           : "maid_id",
                        option        : [],
                        listValueField: 'employee_name',
                        permission    : !!this.$can('view_all_hotel_house_keeping') && !!this.$isAdmin
                    },
                    {
                        title : this.$t('date'),
                        type  : "range-picker",
                        key   : "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title         : this.$t('confirmed'),
                        type          : "drop-down-filter",
                        key           : "confirmed",
                        option        : [
                            {
                                id  : '0',
                                name: this.$t('no'),
                            },
                            {
                                id  : '1',
                                name: this.$t('yes'),
                            },
                        ],
                        listValueField: 'name'
                    },
                    {
                        title         : this.$t('employee_tags'),
                        type          : "multi-select-filter",
                        key           : "employee_tags",
                        option        : [],
                        listValueField: 'name',
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'dropdown',
                actions          : [
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_hotel_house_keeping')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/hotel/house-keeping/`,
                        name     : 'delete',
                        modifier : row => this.$can('update_hotel_house-keeping')
                    }
                ],
            }
        }
    },
    mounted() {
        this.hydrateDependentFiltersFromUrl();
        window.addEventListener('popstate', this.hydrateDependentFiltersFromUrl);
    },
    beforeDestroy() {
        window.removeEventListener('popstate', this.hydrateDependentFiltersFromUrl);
    },
    methods: {
        hydrateDependentFiltersFromUrl() {
            const query = new URLSearchParams(window.location.search);
            const hotels = this.hotel.id || query.get('hotels') || '';
            const date = query.get('date') || '';

            this.getFilterValues({
                hotels,
                date,
            });
        },
        normalizeFilterValue(value) {
            if ([undefined, null, ''].includes(value)) {
                return '';
            }

            if (Array.isArray(value)) {
                return value
                    .map(item => item?.toString().trim())
                    .filter(item => item)
                    .join(',');
            }

            return value.toString().split(',')
                .map(item => item.trim())
                .filter(item => item)
                .join(',');
        },
        normalizeSelectOptions(options = []) {
            return options.map(item => {
                const normalizedId = Number(item.id);

                return {
                    ...item,
                    id: Number.isNaN(normalizedId) ? item.id : normalizedId,
                };
            });
        },
        clearDependentFilters(value = null) {
            const maidFilter = this.options.filters.find(item => item.key === 'maid_id');
            const floorFilter = this.options.filters.find(item => item.key === 'floor');

            floorFilter.option = [];
            maidFilter.option = [];
            this.$set(floorFilter, 'active', undefined);
            this.$set(maidFilter, 'active', undefined);

            if (value && typeof value === 'object') {
                value.floor = '';
                value.maid_id = '';
            }
        },
        formatTerminateDateFrom(value) {
            const dateValue = value?.date;

            if (!dateValue) {
                return '';
            }

            if (typeof dateValue === 'string') {
                try {
                    const parsed = JSON.parse(dateValue);
                    return parsed?.start || parsed?.end || '';
                } catch (e) {
                    return dateValue;
                }
            }

            if (typeof dateValue === 'object') {
                return dateValue.start || dateValue.end || '';
            }

            return '';
        },
        getFilterValues(value) {
            const Error        = error => this.$toastr.e(error.response.data.message)
            const optionFilter = this.options.filters.find(item => item.key === 'maid_id');
            const floorFilter  = this.options.filters.find(item => item.key === 'floor');
            const hotels = this.normalizeFilterValue(value.hotels);
            const currentHotels = this.normalizeFilterValue(
                this.hotel.id || new URLSearchParams(window.location.search).get('hotels') || ''
            );
            const terminateDateFrom = this.formatTerminateDateFrom(value);
            const terminateDateQuery = terminateDateFrom ? `&terminate_date_from=${encodeURIComponent(terminateDateFrom)}` : '';

            if (hotels !== currentHotels) {
                this.clearDependentFilters(value);
            }

            axiosGet(`${TENANT_BASE_URL}selectable/hotel/room?group=floor&format=floor${hotels ? '&hotel_id=' + hotels : ''}`)
                .then(({data}) => floorFilter.option = this.normalizeSelectOptions(data))
                .catch(Error)
            axiosGet(`${TENANT_BASE_URL}selectable/hotel/member?field_id=employee_id${hotels ? '&hotel_id=' + hotels : ''}${terminateDateQuery}`)
                .then(({data}) => optionFilter.option = this.normalizeSelectOptions(data))
                .catch(Error)
        },
    },
}
